export default __webpack_public_path__ + "static/media/FACINGS.703d83be.svg";